// extracted by mini-css-extract-plugin
export default {"footer":"F8joQZ7Q1dc6NQ3RaJD7","hr":"h2nLLl8Tj6lr_0FO68o6","container":"wbeslzoK6jDxa2PVbaRq","terms":"QF5eJrLnNqObpjAdLv47","social":"aaRaiTwsvtB7m7Bucxnr"};